import styled from "styled-components";

export const Container = styled.div(({ color }) => ({
  backgroundColor: color,
  width: "12rem",
  height: "100%",
  borderRadius: "1.1rem",
  height: "2.2rem",
  display: "flex",
  justifyContent: "space-around",
  position: "relative",
  alignItems: "center",
  cursor: "pointer",
}));

export const KWhText = styled.div(({ color, isKW }) => ({
  transition: "all 0.3s ease",
  position: "absolute",
  zIndex: 1000,
  userSelect: "none",
  left: "1.75rem",
  color: isKW ? "#FFFFFF" : color,
}));

export const KWText = styled.div(({ color, isKW }) => ({
  transition: "all 0.3s ease",
  position: "absolute",
  zIndex: 1000,
  userSelect: "none",
  right: "1.75rem",
  color: !isKW ? "#FFFFFF" : color,
}));

export const Switch = styled.div(({ isKW }) => ({
  transition: "all 0.3s ease",
  height: "100%",
  backgroundColor: "#FFFFFF",
  width: "50%",
  borderRadius: "1.1rem",
  marginLeft: isKW && "6rem",
  marginRight: !isKW && "6rem",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/GraphSwitch/GraphSwitch.styles.js